import React, { useMemo } from 'react';
import { Typography } from '@hpi-sox/hpstellar-core';

const useThreeDTooltipProps = (width, device) =>
    useMemo(
        () => ({
            description:
                width < 1024 ? (
                    'Drag to rotate. Pinch to zoom'
                ) : (
                    <Typography tag="div" className="imageModal-tooltip-content">
                        <span>Using Mouse or Trackpad</span>
                        <ul>
                            <li>Click on the 3D image and drag to see different angles</li>
                            <li>Scroll up or down to zoom</li>
                            <li>Pinch fingers open or close to zoom</li>
                        </ul>
                        <span>Using Keyboard</span>
                        <ul>
                            <li>Tab to the 3D image</li>
                            <li>Use the arrow keys to rotate</li>
                            <li>On a PC, use Page UP or Page Down to zoom</li>
                            <li>On a Mac, press the fn key and the up or down arrows to zoom</li>
                        </ul>
                    </Typography>
                ),
            title: device === 'mobile' ? '' : 'ROTATE AND ZOOM IN 3D',
            triggerElementLabel: 'How to use',
        }),
        [width, device],
    );

export default useThreeDTooltipProps;
